import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { useFormStepper } from '@1trading/react/components/ui/form-stepper';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingTitle } from '@/components/ui/page-heading';
import type { AmlQuestionnaireEmploymentStatus } from '@/features/onboarding/aml-questionnaire/schema';
import { AML_EMPLOYMENT_STATUS_ANSWERS } from '@/services/api/profile/aml';

const AmlQuestionnaireFieldsetEmploymentStatusLegend = () => {
  const { t } = useTranslation();

  return (
    <PageHeading asChild>
      <legend>
        <PageHeadingTitle>{t('AMLQuestionnaire.employmentStatus.title')}</PageHeadingTitle>
      </legend>
    </PageHeading>
  );
};
AmlQuestionnaireFieldsetEmploymentStatusLegend.displayName = 'AmlQuestionnaireFieldsetEmploymentStatusLegend';

const AmlQuestionnaireFieldsetEmploymentStatus = () => {
  const form = useFormContext<AmlQuestionnaireEmploymentStatus>();
  const { nextStepDeferred } = useFormStepper();
  const { t } = useTranslation();

  return (
    <FormField
      name="employmentStatus"
      control={form.control}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="sr-only">{t('AMLQuestionnaire.employmentStatus.title')}</FormLabel>
          <FormControl>
            <RadioGroup
              className="!mt-0"
              defaultValue={field.value}
              variant="cards"
              aria-label={t('AMLQuestionnaire.employmentStatus.title')}
              onValueChange={(value) => {
                field.onChange(value);
                nextStepDeferred();
              }}
            >
              {AML_EMPLOYMENT_STATUS_ANSWERS.map((answer) => (
                <FormItem key={answer}>
                  <RadioGroupItemCard variant="outline">
                    <FormControl>
                      <RadioGroupItem value={answer} />
                    </FormControl>
                    <FormLabel contained onClick={() => nextStepDeferred()}>
                      {t(`AMLQuestionnaire.employmentStatus.options.${answer}`)}
                    </FormLabel>
                  </RadioGroupItemCard>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
AmlQuestionnaireFieldsetEmploymentStatus.displayName = 'AmlQuestionnaireFieldsetEmploymentStatus';
AmlQuestionnaireFieldsetEmploymentStatus.isAutoNextStep = true;

export { AmlQuestionnaireFieldsetEmploymentStatus, AmlQuestionnaireFieldsetEmploymentStatusLegend };
